
import {
    defineComponent,
    inject,
    watch,
} from "vue";
import Edit from "@/components/cigo-admin-core/pages/template/Edit.vue";

export default defineComponent({
    name: "CigoEditRuleGroup",
    components: {
        Edit
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let formData = {
            id: props.layerData.recordCurr ? props.layerData.recordCurr.id : null,
            title: props.layerData.recordCurr ?
                props.layerData.recordCurr.title : "",
            sort: props.layerData.recordCurr ?
                props.layerData.recordCurr.sort : 100,
            summary: props.layerData.recordCurr ?
                props.layerData.recordCurr.summary : "",
            rules: props.layerData.recordCurr ?
                props.layerData.recordCurr.rules : [],
        };
        const formItemRules = {
            title: [{
                required: true,
                message: "请输入角色名"
            }],
            sort: [{
                    required: true,
                    message: "请配置角色排序"
                },
                {
                    type: "integer",
                    transform: (value: any) => {
                        return Number(value);
                    },
                    message: "排序为正整数"
                }
            ]
        };

        return {
            formData,
            formItemRules,
        };
    }
});
